<qrcode [errorCorrectionLevel]="'Q'" [width]="width()" [qrdata]="qrCodeValue"></qrcode>
